import _ from 'underscore';

const AssetGroupNegativeReferenceId = -21;

export const viewModelToBulkModelForSearchThemes = (searchThemes, assetGroupId = AssetGroupNegativeReferenceId) => {
  const searchThemesresult =
    _.compact(searchThemes.map((item) => {
      if (item.Status === 'Deleted') {
        return ({
          AssetGroupId: assetGroupId,
          SearchTheme: item.SearchTheme,
          AssetGroupSearchThemeId: item.Id,
          Status: item.Status,
        });
      }

      if (item.Id) {
        return '';
      }

      return ({
        AssetGroupId: assetGroupId,
        SearchTheme: item.SearchTheme,
      });
    }));
  return { AssetGroupSearchThemes: searchThemesresult };
};
